<template>
    
    <div v-if="deluxe" class="project-tracker-scroll">
        <ul class="project-tracker overflow-visible">
            <li
                v-for="item in displayStageIcons"
                :key="item.originalIndex"
                :class="trackerItemClass(item.originalIndex)"
            >
                <a
                    :class="trackerLinkClass(item.originalIndex)"
                    href="#"
                    :title="GetStepTitle(item)"
                    @click.prevent="ClickStep(item.originalIndex)"
                >
                    <svg
                        v-if="item.originalIndex < currentStepIndex"
                        class="project-tracker__check"
                        width="13"
                        height="10"
                        viewBox="0 0 13 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path d="M11.6667 1L4.33333 8.33333L1 5" stroke="#F5F5F5" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    {{item.name}}
                </a>
            </li>
        </ul>
        <button class="d-none" ref="modalCaller" data-bs-toggle="modal" data-bs-target="#StepModal" />
    </div>
    <div v-else class="custom2-container">
         <nav class="custom2-breadcrumbs">
             <a
             class="custom2-breadcrumbs__item"
             :class="{
                 'custom2-breadcrumbs__item is-inprogress' : currentStepIndex==item.originalIndex,
                 'custom2-breadcrumbs__item is-completed' : item.originalIndex < currentStepIndex,
                 'custom2-breadcrumbs__item is-pending' :item.originalIndex > currentStepIndex
             }"
             v-for="item in displayStageIcons" :key="item.originalIndex"
             :title="GetStepTitle(item)"
             
             @click="ClickStep(item.originalIndex)"
             >
             <span class="custom2-breadcrumbs__label">{{item.name}}</span>
             </a>
         </nav>
         <button class="d-none" ref="modalCaller" data-bs-toggle="modal" data-bs-target="#StepModal" />
    </div>
     <Modal idModal="StepModal" :headerTitle="modalData.processName" >
         <form>
             <div class="form-group">
                 <label>Status </label>
                 <input type="text" :value="modalData.status" class="form-control-plaintext" readonly  />
             </div>
             <div class="form-group">
                 <label>Updated At </label>
                 <input type="text" :value="modalData.updatedAt" class="form-control-plaintext" readonly  />
             </div>
         </form>
         <template v-slot:actions>
         <div></div>
         <button type="button" ref="closeStageModal" class="btn btn-outline-danger" data-bs-dismiss="modal">Close</button>
       </template>
     </Modal>
 </template>
 
 <script>
 import 'dotenv/config'
 import Modal from '@/components/layout/Modal.vue'
 import {stageIcons} from '@/helpers/utilities.js'
 import {mapGetters} from 'vuex'
 export default {
     name : 'StepItem2',
     props : ['stage', 'stageDetails', 'activeIndex', 'deluxe'],
     components : {
         Modal
     },
     data(){
 
         let projectUrl = process.env.VUE_APP_PROJECT_URL
         let boqUrl = process.env.VUE_APP_BOQ_URL
         let dotNetUrl = process.env.VUE_APP_DOTNET_URL
         return {            
             stepDetails : {
                 stepName : '',
                 stepNumber : 1
             },
             modalData :{
                 processName : '',
                 updatedAt : '',
                 status : ''
             },
             processName : '',
             stageIcons : stageIcons,
             stageActions : [
                 'is-pending',
                 'is-inprogress',
                 'is-completed',
                 'is-skipped',
                 'is-canceled',
             ],
             stageActionsText : [
                 'Pending',
                 'In Progress',
                 'Completed',
                 'Skipped',
                 'Canceled',
             ],
             urlList :[
                 projectUrl + '/project/idHere',
                 boqUrl + '/boq/idHere',
                 boqUrl + '/boq/idHere/quotation/list',
                 boqUrl + '/boq/idHere/quotation/list',
                 dotNetUrl + '/tradepackage/idHere',
                 dotNetUrl + '/contingencyv2/summary/idHere',
                 dotNetUrl + '/PurchaseOrder/purchaseordersList?projectId=idHere',
                 dotNetUrl + '/progressclaim/idHere',
                 dotNetUrl + '/clientinvoice/idHere',
                 dotNetUrl + '/change-requestV2/idHere',
                 '',
 
             ]
         }
     },
     methods :{
         trackerItemClass(key){
             return {
                 completed : key < this.currentStepIndex,
                 active : key === this.currentStepIndex,
                 relative : key === this.currentStepIndex,
             }
         },
         trackerLinkClass(key){
             const classUrl = [
                 'nav-link-project-dashboard',
                 'nav-link-project-boq',
                 'nav-link-project-quotation',
                 'nav-link-project-quotation',
                 'nav-link-trade-package',
                 'nav-link-contingency',
                 'nav-link-purchase-order',
                 'nav-link-client-progress-claim',
                 'nav-link-client-invoice',
                 'nav-link-change-requestV2',
                 '',
             ]

             return classUrl[key] || ''
         },
         GetStepTitle(item){
             const status = this.projectInfo.stageProcess[item.originalIndex]
                 ? this.stageActionsText[this.projectInfo.stageProcess[item.originalIndex].status - 1]
                 : 'Inactive'

             return `${item.name} - ${this.$t(status)}`
         },
         ClickStep(data){
             if(data >3){
                 window.location.href = this.urlList[data].replace('idHere',this.projectInfo.projectOldId)
             }else{
                 window.location.href = this.urlList[data].replace('idHere',this.projectInfo._id)
             }
             // if(!data){
             //     return
             // }
             // this.modalData.processName = this.stageIcons[data.stage -1].name
             // this.modalData.status = this.stageActionsText[data.status -1] 
             // this.modalData.updatedAt = ReformatDate(data.updateAt) 
             // this.$refs.modalCaller.click()
         }
     },
     computed : {
         ...mapGetters(['projectInfo']),
        displayStageIcons(){
            if(!this.deluxe){
                return this.stageIcons.map((item, index) => ({
                    ...item,
                    originalIndex : index
                }))
            }

            const deluxeLabels = [
                this.$t('Project Info'),
                this.$t('Bill Of Quantity'),
                this.$t('Quotation'),
                this.$t('Contract'),
                this.$t('Procurement'),
                this.$t('Contingency'),
                this.$t('Purchase Order'),
                this.$t('Progress Claim'),
                this.$t('Client Invoice'),
                this.$t('Change Request'),
                this.$t('Final Account'),
            ]
            const hiddenStages = [3, 10]

            return this.stageIcons.map((item, index) => ({
                 ...item,
                 name: deluxeLabels[index] || item.name,
                 originalIndex : index
             })).filter(item => hiddenStages.indexOf(item.originalIndex)<0)
        },
         currentStepIndex(){
             if(this.activeIndex !== undefined && this.activeIndex !== null){
                 return this.activeIndex
             }

             return (this.projectInfo.stage || 1) - 1
         }
     },
 }
</script>
